module.exports = __webpack_public_path__ + "static/media/trash.df4ed3ae.svg";